module.exports = __webpack_public_path__ + "img/info1.7e4cf67b.jpg";